import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import {
  MASTER_TEMPLATE_NOT_SAVED_CHANGES_FEATURE_KEY,
  MasterTemplateNotSavedChangesEntity,
  masterTemplateNotSavedChangesAdapter,
} from './master-template-not-saved-changes.reducer';
import { EntityState } from '@ngrx/entity';
import { Dictionary } from '@ngrx/entity/src/models';

const { selectEntities, selectTotal } = masterTemplateNotSavedChangesAdapter.getSelectors();

const getMasterTemplateNotSavedChangesFeatureState = createFeatureSelector<
  EntityState<MasterTemplateNotSavedChangesEntity>
>(MASTER_TEMPLATE_NOT_SAVED_CHANGES_FEATURE_KEY);

export const getMasterTemplatesNotSavedChangesEntities = (): MemoizedSelector<
  object,
  Dictionary<MasterTemplateNotSavedChangesEntity>
> =>
  createSelector(
    getMasterTemplateNotSavedChangesFeatureState,
    (state: EntityState<MasterTemplateNotSavedChangesEntity>) => selectEntities(state)
  );

export const getMasterTemplatesNotSavedChangesTotal = (): MemoizedSelector<object, number> =>
  createSelector(
    getMasterTemplateNotSavedChangesFeatureState,
    (state: EntityState<MasterTemplateNotSavedChangesEntity>) => selectTotal(state)
  );

export const getNotSavedChangesForMasterTemplate = (
  templateId: string
): MemoizedSelector<object, MasterTemplateNotSavedChangesEntity | undefined> =>
  createSelector(
    getMasterTemplatesNotSavedChangesEntities(),
    (entities: Dictionary<MasterTemplateNotSavedChangesEntity>) => entities[templateId]
  );
